import React from 'react';

const Order = () => <div className="coop-l-container">Make an order</div>;

export default Order;
